import React from "react";
import { FeatureArticleRichText } from "web/react/components/feature-article/feature-article-rich-text";
import { withHardBreaks } from "web/react/components/feature-article/utils";
import { Heading } from "web/react/emo/heading";
import { VStack } from "web/react/emo/v-stack/v-stack";

interface FeatureArticleTextProps {
    heading: string | null;
    markdown: string;
}

export function FeatureArticleText({
    heading,
    markdown,
}: FeatureArticleTextProps): React.ReactElement {
    return (
        <VStack spacing="sm">
            {heading && (
                <Heading as="h2" textStyle="hero">
                    {heading}
                </Heading>
            )}
            <FeatureArticleRichText>{withHardBreaks(markdown)}</FeatureArticleRichText>
        </VStack>
    );
}
